import React from "react";
import { observer } from "mobx-react";
import { useStore } from "../stores/store";

interface AppProvidersProps {
  children: React.ReactNode;
}

const AppProviders: React.FC<AppProvidersProps> = observer(({ children }) => {
  const { globalStore } = useStore();

  // Ensure dark mode class is always removed
  React.useEffect(() => {
    document.documentElement.classList.remove("dark");
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {children}
    </div>
  );
});

export default AppProviders;
